var map = {
	"./barcode1.png": 254,
	"./brand/adidas.jpg": 20534,
	"./brand/adidas.png": 67680,
	"./brand/colgate.png": 63361,
	"./brand/samsung.png": 63962,
	"./customer/customer1.jpg": 20004,
	"./customer/customer10.jpg": 26362,
	"./customer/customer2.jpg": 92461,
	"./customer/customer3.jpg": 66170,
	"./customer/customer4.jpg": 21106,
	"./customer/customer5.jpg": 9294,
	"./customer/customer6.jpg": 84559,
	"./customer/customer7.jpg": 24144,
	"./customer/customer8.jpg": 27651,
	"./customer/customer9.jpg": 16695,
	"./customer/no-imagecustomer.png": 2261,
	"./customer/profile.jpg": 14896,
	"./customer/profile2.jpg": 73251,
	"./customer/profile3.jpg": 24147,
	"./customer/profile4.jpg": 72461,
	"./customer/profile5.jpg": 25273,
	"./favicon.png": 24184,
	"./flags/ad.png": 2825,
	"./flags/ae.png": 7635,
	"./flags/af.png": 34664,
	"./flags/ag.png": 48118,
	"./flags/ai.png": 7658,
	"./flags/al.png": 15353,
	"./flags/am.png": 93941,
	"./flags/ao.png": 54255,
	"./flags/ar.png": 80115,
	"./flags/as.png": 99070,
	"./flags/at.png": 73632,
	"./flags/au.png": 57193,
	"./flags/aw.png": 58349,
	"./flags/ax.png": 5432,
	"./flags/az.png": 61318,
	"./flags/ba.png": 11732,
	"./flags/bb.png": 96333,
	"./flags/bd.png": 70857,
	"./flags/be.png": 6089,
	"./flags/bf.png": 94194,
	"./flags/bg.png": 44092,
	"./flags/bh.png": 65581,
	"./flags/bi.png": 17234,
	"./flags/bj.png": 70477,
	"./flags/bl.png": 50077,
	"./flags/bm.png": 20157,
	"./flags/bn.png": 11983,
	"./flags/bo.png": 15419,
	"./flags/bq.png": 4611,
	"./flags/br.png": 71720,
	"./flags/bs.png": 79246,
	"./flags/bt.png": 91391,
	"./flags/bv.png": 64680,
	"./flags/bw.png": 46167,
	"./flags/by.png": 70437,
	"./flags/bz.png": 51673,
	"./flags/ca.png": 23083,
	"./flags/cc.png": 75621,
	"./flags/cd.png": 4462,
	"./flags/cf.png": 20676,
	"./flags/cg.png": 53080,
	"./flags/ch.png": 72049,
	"./flags/ci.png": 47144,
	"./flags/ck.png": 68048,
	"./flags/cl.png": 85678,
	"./flags/cm.png": 87941,
	"./flags/cn.png": 62034,
	"./flags/co.png": 61946,
	"./flags/cr.png": 70243,
	"./flags/cu.png": 5374,
	"./flags/cv.png": 57282,
	"./flags/cw.png": 78878,
	"./flags/cx.png": 59532,
	"./flags/cy.png": 24493,
	"./flags/cz.png": 436,
	"./flags/de.png": 68165,
	"./flags/dj.png": 44669,
	"./flags/dk.png": 38377,
	"./flags/dm.png": 83929,
	"./flags/do.png": 22227,
	"./flags/dz.png": 4412,
	"./flags/ec.png": 58513,
	"./flags/ee.png": 47708,
	"./flags/eg.png": 16817,
	"./flags/er.png": 95823,
	"./flags/es.png": 14695,
	"./flags/et.png": 79051,
	"./flags/fi.png": 36101,
	"./flags/fj.png": 73325,
	"./flags/fk.png": 67631,
	"./flags/fm.png": 57653,
	"./flags/fo.png": 44441,
	"./flags/fr.png": 28823,
	"./flags/ga.png": 34172,
	"./flags/gb.png": 43068,
	"./flags/gd.png": 87814,
	"./flags/ge.png": 88180,
	"./flags/gf.png": 49146,
	"./flags/gg.png": 51062,
	"./flags/gh.png": 95863,
	"./flags/gi.png": 24177,
	"./flags/gl.png": 51893,
	"./flags/gm.png": 42780,
	"./flags/gn.png": 65657,
	"./flags/gp.png": 28403,
	"./flags/gq.png": 31307,
	"./flags/gr.png": 80501,
	"./flags/gs.png": 88471,
	"./flags/gt.png": 51043,
	"./flags/gu.png": 22893,
	"./flags/gw.png": 53470,
	"./flags/gy.png": 27763,
	"./flags/hk.png": 1825,
	"./flags/hn.png": 98081,
	"./flags/hr.png": 90005,
	"./flags/ht.png": 44523,
	"./flags/hu.png": 95269,
	"./flags/id.png": 82328,
	"./flags/ie.png": 45745,
	"./flags/il.png": 67338,
	"./flags/im.png": 12909,
	"./flags/in.png": 52080,
	"./flags/io.png": 82367,
	"./flags/iq.png": 43049,
	"./flags/ir.png": 17715,
	"./flags/is.png": 34401,
	"./flags/it.png": 61955,
	"./flags/je.png": 38536,
	"./flags/jm.png": 59424,
	"./flags/jo.png": 23147,
	"./flags/jp.png": 2615,
	"./flags/ke.png": 57885,
	"./flags/kg.png": 55214,
	"./flags/kh.png": 12822,
	"./flags/ki.png": 37006,
	"./flags/km.png": 63269,
	"./flags/kn.png": 22718,
	"./flags/kp.png": 21756,
	"./flags/kr.png": 7297,
	"./flags/kw.png": 8899,
	"./flags/ky.png": 43174,
	"./flags/kz.png": 67324,
	"./flags/la.png": 44305,
	"./flags/lb.png": 89973,
	"./flags/lc.png": 87591,
	"./flags/li.png": 28130,
	"./flags/lk.png": 16392,
	"./flags/lr.png": 47063,
	"./flags/ls.png": 33753,
	"./flags/lt.png": 70200,
	"./flags/lu.png": 76299,
	"./flags/lv.png": 59167,
	"./flags/ly.png": 52361,
	"./flags/ma.png": 16802,
	"./flags/mc.png": 71325,
	"./flags/md.png": 73351,
	"./flags/me.png": 76294,
	"./flags/mg.png": 74248,
	"./flags/mh.png": 73610,
	"./flags/mk.png": 6721,
	"./flags/ml.png": 26556,
	"./flags/mm.png": 14150,
	"./flags/mn.png": 60555,
	"./flags/mo.png": 83830,
	"./flags/mp.png": 17523,
	"./flags/mq.png": 13431,
	"./flags/mr.png": 73747,
	"./flags/ms.png": 66105,
	"./flags/mt.png": 72293,
	"./flags/mu.png": 15801,
	"./flags/mv.png": 68286,
	"./flags/mw.png": 47015,
	"./flags/mx.png": 90045,
	"./flags/my.png": 68418,
	"./flags/mz.png": 11138,
	"./flags/na.png": 77455,
	"./flags/nc.png": 93902,
	"./flags/ne.png": 3153,
	"./flags/nf.png": 57270,
	"./flags/ng.png": 2565,
	"./flags/ni.png": 27297,
	"./flags/nl.png": 28358,
	"./flags/no.png": 69022,
	"./flags/np.png": 7285,
	"./flags/nr.png": 37111,
	"./flags/nu.png": 94595,
	"./flags/nz.png": 17170,
	"./flags/om.png": 8203,
	"./flags/pa.png": 45290,
	"./flags/pe.png": 72214,
	"./flags/pf.png": 72751,
	"./flags/pg.png": 90929,
	"./flags/ph.png": 42786,
	"./flags/pk.png": 95474,
	"./flags/pl.png": 3435,
	"./flags/pm.png": 90509,
	"./flags/pn.png": 41330,
	"./flags/pr.png": 81198,
	"./flags/ps.png": 57394,
	"./flags/pt.png": 56488,
	"./flags/pw.png": 24057,
	"./flags/py.png": 42547,
	"./flags/qa.png": 85955,
	"./flags/re.png": 25521,
	"./flags/ro.png": 88214,
	"./flags/rs.png": 78786,
	"./flags/ru.png": 74355,
	"./flags/rw.png": 93258,
	"./flags/sa.png": 62390,
	"./flags/sb.png": 8749,
	"./flags/sc.png": 85155,
	"./flags/sd.png": 99799,
	"./flags/se.png": 5201,
	"./flags/sg.png": 93325,
	"./flags/sh.png": 28139,
	"./flags/si.png": 1364,
	"./flags/sk.png": 97482,
	"./flags/sl.png": 65126,
	"./flags/sm.png": 62221,
	"./flags/sn.png": 23501,
	"./flags/so.png": 50664,
	"./flags/sr.png": 52749,
	"./flags/ss.png": 34472,
	"./flags/st.png": 80725,
	"./flags/sv.png": 84402,
	"./flags/sx.png": 28513,
	"./flags/sy.png": 45037,
	"./flags/sz.png": 99226,
	"./flags/tc.png": 76903,
	"./flags/td.png": 61247,
	"./flags/tf.png": 68261,
	"./flags/tg.png": 64664,
	"./flags/th.png": 28973,
	"./flags/tj.png": 77639,
	"./flags/tk.png": 53817,
	"./flags/tl.png": 81533,
	"./flags/tm.png": 57916,
	"./flags/tn.png": 24267,
	"./flags/to.png": 38347,
	"./flags/tr.png": 29960,
	"./flags/tt.png": 74213,
	"./flags/tv.png": 56191,
	"./flags/tw.png": 37434,
	"./flags/tz.png": 27215,
	"./flags/ua.png": 5330,
	"./flags/ug.png": 28001,
	"./flags/um.png": 58259,
	"./flags/us.png": 14499,
	"./flags/us1.png": 45885,
	"./flags/uy.png": 1290,
	"./flags/uz.png": 18743,
	"./flags/va.png": 8442,
	"./flags/vc.png": 92094,
	"./flags/ve.png": 71204,
	"./flags/vg.png": 3653,
	"./flags/vi.png": 86544,
	"./flags/vn.png": 27448,
	"./flags/vu.png": 9380,
	"./flags/wf.png": 77970,
	"./flags/ws.png": 72051,
	"./flags/ye.png": 82336,
	"./flags/yt.png": 26221,
	"./flags/za.png": 82516,
	"./flags/zm.png": 93,
	"./flags/zw.png": 6920,
	"./icons/Calculator.svg": 94564,
	"./icons/Vector.svg": 91307,
	"./icons/add-circle.svg": 20197,
	"./icons/addprofile.svg": 97476,
	"./icons/airplay.svg": 14598,
	"./icons/approve-verified.png": 72937,
	"./icons/approve.png": 59860,
	"./icons/approve.svg": 67828,
	"./icons/arrow-left.svg": 69023,
	"./icons/bar.svg": 86128,
	"./icons/bar1.svg": 1486,
	"./icons/calendars.svg": 95091,
	"./icons/cash.svg": 18261,
	"./icons/cash1.svg": 29543,
	"./icons/check.svg": 73028,
	"./icons/close-circle.svg": 79097,
	"./icons/close-circle1.svg": 56531,
	"./icons/close-icon.png": 30080,
	"./icons/close-icon.svg": 12297,
	"./icons/closes.svg": 5755,
	"./icons/dash3.svg": 40725,
	"./icons/dash4.svg": 54025,
	"./icons/dash5.svg": 50080,
	"./icons/dash6.svg": 59049,
	"./icons/dash7.svg": 20181,
	"./icons/dashboard.svg": 5662,
	"./icons/datepicker.svg": 88404,
	"./icons/debitcard.svg": 90383,
	"./icons/delete-2.svg": 3596,
	"./icons/delete.svg": 77054,
	"./icons/delete1.svg": 59173,
	"./icons/delete7.svg": 95453,
	"./icons/dollar-square.svg": 58315,
	"./icons/dollar.svg": 47029,
	"./icons/download.svg": 3221,
	"./icons/dropdown.svg": 63038,
	"./icons/edit-2.svg": 68955,
	"./icons/edit-5.svg": 43372,
	"./icons/edit-6.svg": 78088,
	"./icons/edit-set.svg": 23322,
	"./icons/edit.svg": 62365,
	"./icons/ellipise.svg": 25017,
	"./icons/ellipise1.svg": 18784,
	"./icons/excel.svg": 66074,
	"./icons/expense.svg": 72902,
	"./icons/expense1.svg": 58081,
	"./icons/eye.svg": 9947,
	"./icons/eye1.svg": 69173,
	"./icons/facebook.png": 23852,
	"./icons/filter.svg": 73232,
	"./icons/folder-minus.svg": 26928,
	"./icons/fullscreen.svg": 73577,
	"./icons/google.png": 34612,
	"./icons/loader.svg": 94760,
	"./icons/log-out.svg": 12586,
	"./icons/macbook.svg": 3493,
	"./icons/mail.svg": 62711,
	"./icons/menu-icon-01.svg": 88981,
	"./icons/menu-icon-02.svg": 97722,
	"./icons/menu-icon-04.svg": 8540,
	"./icons/menu-icon-05.svg": 26027,
	"./icons/menu-icon-06.svg": 7225,
	"./icons/menu-icon.svg": 12455,
	"./icons/minus.svg": 68032,
	"./icons/notification-bing.svg": 78865,
	"./icons/order.svg": 40598,
	"./icons/pause.svg": 4315,
	"./icons/pause1.svg": 4682,
	"./icons/pdf.svg": 68370,
	"./icons/places.svg": 60859,
	"./icons/plus-circle.svg": 95796,
	"./icons/plus.svg": 94893,
	"./icons/plus1.svg": 4866,
	"./icons/plus11.svg": 10169,
	"./icons/plus12.svg": 96945,
	"./icons/pos.svg": 12961,
	"./icons/power.svg": 18205,
	"./icons/printer.svg": 42230,
	"./icons/product.svg": 27881,
	"./icons/pur-invoice.svg": 14388,
	"./icons/purchase.svg": 11314,
	"./icons/purchase1.svg": 76682,
	"./icons/quotation1.svg": 72286,
	"./icons/report.svg": 76757,
	"./icons/return1.svg": 66947,
	"./icons/reverse.svg": 88787,
	"./icons/right-arrow.svg": 54652,
	"./icons/sale.svg": 94703,
	"./icons/sales.svg": 29053,
	"./icons/sales1.svg": 6950,
	"./icons/salesinvoice.svg": 97609,
	"./icons/scan.svg": 73873,
	"./icons/scanner.svg": 45987,
	"./icons/scanner1.svg": 25134,
	"./icons/scanners.svg": 88258,
	"./icons/search-white.svg": 67919,
	"./icons/search-whites.svg": 79233,
	"./icons/search.svg": 77618,
	"./icons/settings.svg": 55895,
	"./icons/sidebar-delete-icon.svg": 22699,
	"./icons/sidebar-icon-01.png": 51039,
	"./icons/sidebar-icon-01.svg": 875,
	"./icons/sidebar-icon-02.png": 82829,
	"./icons/sidebar-icon-02.svg": 51715,
	"./icons/sidebar-icon-03.png": 56132,
	"./icons/sidebar-icon-03.svg": 85093,
	"./icons/siderbar-icon1.png": 39511,
	"./icons/siderbar-icon1.svg": 83772,
	"./icons/siderbar-icon2.png": 1731,
	"./icons/siderbar-icon2.svg": 89619,
	"./icons/siderbar-icon3.png": 11950,
	"./icons/siderbar-icon3.svg": 39010,
	"./icons/sun-icon.png": 22865,
	"./icons/sun-icon.svg": 98248,
	"./icons/time.svg": 73763,
	"./icons/transcation.svg": 34416,
	"./icons/transfer1.svg": 9925,
	"./icons/trash.svg": 3996,
	"./icons/trash12.svg": 86011,
	"./icons/upload.svg": 68945,
	"./icons/user.svg": 22676,
	"./icons/users.svg": 70840,
	"./icons/users1.svg": 89602,
	"./icons/wallet.svg": 86668,
	"./icons/wallet1.svg": 2181,
	"./img-01.jpg": 98438,
	"./img-02.jpg": 71921,
	"./img-03.jpg": 50794,
	"./img-04.jpg": 47522,
	"./img-05.jpg": 29967,
	"./lasaro2.jpg": 7975,
	"./lasaro_icon.svg": 4834,
	"./lasaro_icon2.svg": 38583,
	"./layout-01.png": 14477,
	"./layout-02.png": 74357,
	"./layout-03.png": 71178,
	"./layout-04.png": 86112,
	"./layout-ltr.png": 45816,
	"./layout-rtl.png": 36328,
	"./login.jpg": 35468,
	"./logo-small.png": 47623,
	"./logo-white.png": 7038,
	"./logo.png": 15080,
	"./logo_lg.jpg": 35179,
	"./logo_sm.jpg": 72801,
	"./mobileframe.png": 18466,
	"./product/macbook.png": 2550,
	"./product/noimage.png": 87849,
	"./product/product1.jpg": 63442,
	"./product/product10.jpg": 24416,
	"./product/product11.jpg": 95777,
	"./product/product12.jpg": 43194,
	"./product/product13.jpg": 73938,
	"./product/product15.jpg": 45351,
	"./product/product17.jpg": 6809,
	"./product/product19.jpg": 16362,
	"./product/product2.jpg": 52513,
	"./product/product20.jpg": 29186,
	"./product/product21.jpg": 82834,
	"./product/product22.jpg": 20430,
	"./product/product23.jpg": 478,
	"./product/product24.jpg": 43730,
	"./product/product28.jpg": 46660,
	"./product/product29.jpg": 20307,
	"./product/product3.jpg": 85422,
	"./product/product30.jpg": 68113,
	"./product/product31.jpg": 55345,
	"./product/product32.jpg": 57961,
	"./product/product33.jpg": 66487,
	"./product/product34.jpg": 83174,
	"./product/product35.jpg": 83286,
	"./product/product36.jpg": 68334,
	"./product/product37.jpg": 32953,
	"./product/product4.jpg": 49417,
	"./product/product44.jpg": 9638,
	"./product/product45.jpg": 66800,
	"./product/product46.jpg": 80471,
	"./product/product47.jpg": 45661,
	"./product/product48.jpg": 19785,
	"./product/product48.png": 5846,
	"./product/product49.jpg": 86603,
	"./product/product5.jpg": 8809,
	"./product/product50.jpg": 51419,
	"./product/product51.jpg": 73954,
	"./product/product52.jpg": 26335,
	"./product/product53.jpg": 78483,
	"./product/product54.jpg": 20485,
	"./product/product55.jpg": 63921,
	"./product/product56.jpg": 11306,
	"./product/product57.jpg": 35592,
	"./product/product58.jpg": 6951,
	"./product/product59.jpg": 99690,
	"./product/product6.jpg": 11472,
	"./product/product60.jpg": 70141,
	"./product/product61.png": 42830,
	"./product/product62.png": 65055,
	"./product/product63.png": 38025,
	"./product/product64.png": 44794,
	"./product/product65.png": 35365,
	"./product/product66.png": 31475,
	"./product/product67.png": 95320,
	"./product/product68.png": 9464,
	"./product/product69.jpg": 38030,
	"./product/product7.jpg": 47478,
	"./product/product8.jpg": 41252,
	"./product/product9.jpg": 86023,
	"./profiles/avatar-01.jpg": 80170,
	"./profiles/avatar-02.jpg": 40638,
	"./profiles/avatar-03.jpg": 26440,
	"./profiles/avatar-04.jpg": 51528,
	"./profiles/avatar-05.jpg": 81050,
	"./profiles/avatar-06.jpg": 9407,
	"./profiles/avatar-07.jpg": 33519,
	"./profiles/avatar-08.jpg": 97828,
	"./profiles/avatar-09.jpg": 77943,
	"./profiles/avatar-10.jpg": 41642,
	"./profiles/avatar-100.jpg": 8534,
	"./profiles/avatar-11.jpg": 46317,
	"./profiles/avatar-12.jpg": 68103,
	"./profiles/avatar-13.jpg": 69429,
	"./profiles/avatar-14.jpg": 17171,
	"./profiles/avatar-15.jpg": 22374,
	"./profiles/avatar-16.jpg": 17444,
	"./profiles/avatar-17.jpg": 57533,
	"./profiles/avatar-18.jpg": 17712,
	"./profiles/avatar-19.jpg": 58494,
	"./profiles/avatar-20.jpg": 48476,
	"./profiles/avatar-21.jpg": 83325,
	"./profiles/avatar-22.jpg": 38053,
	"./profiles/avatar-23.jpg": 42259,
	"./profiles/avatar-24.jpg": 76863,
	"./profiles/avatar-25.jpg": 89641,
	"./profiles/avatar-26.jpg": 36161,
	"./profiles/avatar-27.jpg": 15177,
	"./profiles/avatar-28.jpg": 82279,
	"./profiles/avatar-29.jpg": 37663,
	"./profiles/avatar-30.jpg": 49116,
	"./profiles/avator1.jpg": 26946,
	"./supplier/supplier1.png": 44916,
	"./supplier/supplier10.png": 25557,
	"./supplier/supplier2.png": 75694,
	"./supplier/supplier3.png": 72663,
	"./supplier/supplier4.png": 97093,
	"./supplier/supplier5.png": 43038,
	"./supplier/supplier6.png": 48075,
	"./supplier/supplier7.png": 44648,
	"./supplier/supplier8.png": 61302,
	"./supplier/supplier9.png": 78552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25459;